import deleteSociety from 'utils/deleteSociety';

export default [
  {
    icon: 'ni-eye',
    text: 'Ver Socios',
    url: '/socios',
  },
  /*
    {
      icon: 'ni-file-text',
      text: 'Ver Documentos',
      url: '/documentos'
    },
    */
  {
    icon: 'ni-edit',
    text: 'Editar',
    url: '/perfil-sociedad/datos',
  },
  {
    icon: 'ni-trash',
    text: 'Eliminar',
    action: deleteSociety,
  },
];